import routes from "../consts/routes.json";
import { logout } from "../services/JwtService";

/**
 * Diese View stellt aktuell nichts dar, sendet den Benutzer nach dem Logout allerdings einfach zur Login-Maske weiter.
 * @returns {null}
 * @constructor
 */
function LogoutView({ history }) {
    logout();
    history.push(routes.LOGIN);
    return null;
}

export default LogoutView;
